import React from 'react';
import Header from './Header';

const PageWrapper = ({ children, headerProps }) => {
    return (
        <div className={"position-relative"}>
            <Header {...headerProps} />
            <div className='p-4 pt-0'>
                {children}
            </div>
        </div>
    );
};

export default PageWrapper;
